import React, { useState } from 'react';
import { useCart } from '../../contexts/CartContext';
import { useAuth } from '../../contexts/AuthContext';
import './ProductCard.scss';

const ProductCard = ({ product, showBadge = false, onLoginRequired }) => {
  const {
    name,
    code,
    sale_price,
    sale_discount_price,
    is_on_sale,
    is_new,
    current_stock,
    image_url,
    images
  } = product;

  // Convertir precios a números (vienen como strings desde la API)
  const salePriceNum = parseFloat(sale_price) || 0;
  const discountPriceNum = parseFloat(sale_discount_price) || 0;

  const displayPrice = is_on_sale && discountPriceNum > 0 ? discountPriceNum : salePriceNum;
  const hasDiscount = is_on_sale && discountPriceNum > 0 && discountPriceNum < salePriceNum;
  const isOutOfStock = current_stock <= 0;

  // Función para obtener la URL de la imagen del producto
  const getProductImageUrl = () => {
    // Si existe el array de imágenes del nuevo sistema
    if (images && images.length > 0) {
      // Buscar la imagen principal o tomar la primera
      const primaryImage = images.find(img => img.is_primary) || images[0];

      // Construir URL base sin /api/v1
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';
      const baseUrl = apiUrl.replace(/\/api\/v1\/?$/, '');

      // Usar medium_url para el preview
      return `${baseUrl}${primaryImage.medium_url || primaryImage.url}`;
    }

    // Fallback al sistema antiguo si existe
    return image_url;
  };

  const productImageUrl = getProductImageUrl();

  const formatPrice = (value) => {
    return value % 1 === 0 ? value.toFixed(0) : value.toFixed(2);
  };

  const getBadgeText = () => {
    if (showBadge && is_new) return 'NUEVO';
    if (hasDiscount) {
      const discount = Math.round(((salePriceNum - discountPriceNum) / salePriceNum) * 100);
      return `-${discount}%`;
    }
    return null;
  };

  const badgeText = getBadgeText();
  const { addToCart, isInCart, getItemQuantity } = useCart();
  const { isAuthenticated } = useAuth();
  const [showSuccess, setShowSuccess] = useState(false);

  const handleAddToCart = (e) => {
    e.stopPropagation();

    // Si no está autenticado, requerir login
    if (!isAuthenticated) {
      if (onLoginRequired) {
        onLoginRequired();
      }
      return;
    }

    // Agregar al carrito
    addToCart(product, 1);

    // Mostrar mensaje de éxito
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 2000);
  };

  const inCart = isInCart(product.id);
  const cartQuantity = getItemQuantity(product.id);

  return (
    <div className="product-card">
      {badgeText && (
        <div className={`product-card__badge ${hasDiscount ? 'product-card__badge--sale' : ''} ${is_new ? 'product-card__badge--new' : ''}`}>
          {badgeText}
        </div>
      )}

      <div className="product-card__image">
        {productImageUrl ? (
          <img src={productImageUrl} alt={name} />
        ) : (
          <div className="product-card__image-placeholder">
            <span>Sin imagen</span>
          </div>
        )}
      </div>

      <div className="product-card__content">
        <h3 className="product-card__name">{name}</h3>

        <div className="product-card__price">
          {hasDiscount && (
            <span className="product-card__price-original">${formatPrice(salePriceNum)}</span>
          )}
          <span className="product-card__price-current">
            ${formatPrice(displayPrice)}
          </span>
        </div>

        {isAuthenticated && (
          <button
            className={`product-card__add-btn ${inCart ? 'product-card__add-btn--in-cart' : ''}`}
            onClick={handleAddToCart}
          >
            {inCart ? `En carrito (${cartQuantity})` : 'Agregar al carrito'}
          </button>
        )}

        {!isAuthenticated && (
          <button
            className="product-card__login-btn"
            onClick={handleAddToCart}
          >
            Iniciar sesión para comprar
          </button>
        )}

        {showSuccess && (
          <div className="product-card__success-toast">
            Agregado al carrito
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
